<template>
  <align small-gap>
    <pill-dropdown
      v-model="localSort"
      :options="optionsArray"
    />

    <icon-button
      v-show="activeOption"
      :tooltip="directionTooltip"
      :icon="directionIcon"
      @click="changeDirection"
    />
  </align>
</template>

<script>
import Align from './Align';
import IconButton from './IconButton';
import PillDropdown from './PillDropdown';

import { CARD_STAT_FIELDS } from '../constants';

export default {
  components: {
    Align,
    IconButton,
    PillDropdown,
  },

  props: {
    sort: String,
    direction: String,
    options: Array,
  },

  data() {
    return {
      localSort: this.sort,
      localDirection: this.direction,
    };
  },

  watch: {
    sort(value) {
      this.localSort = value;
    },

    localSort(value) {
      this.$emit('update:sort', value);
    },

    direction(value) {
      this.localDirection = value;
    },

    localDirection(value) {
      this.$emit('update:direction', value);
    },
  },

  computed: {
    optionsArray() {
      return this.options.map((field) => CARD_STAT_FIELDS.find((stat) => stat.value === field));
    },

    activeOption() {
      return this.optionsArray.find(({ value }) => value === this.localSort);
    },

    directionIcon() {
      return this.localDirection === 'desc' ? 'arrow_downward' : 'arrow_upward';
    },

    directionTooltip() {
      return this.localDirection === 'desc' ? 'Switch to Ascending' : 'Switch to Descending';
    },
  },

  methods: {
    changeDirection() {
      if (this.localDirection === 'desc') {
        this.localDirection = 'asc';
      } else {
        this.localDirection = 'desc';
      }
    },
  },
};
</script>
